import { XemploLoader } from '@xemplo/loader';

import { useConfirmLogin } from './hooks';

export function ConfirmLogin() {
  useConfirmLogin();
  return <XemploLoader />;
}
